import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import LoanReportPage from './LoanReport';

const LoanReport = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Cartrea de Creditos' pageTitle='Reportes' />
                <LoanReportPage />
            </div>
        </React.Fragment>
    )
}

export default LoanReport;